import { PageController } from '@client/components/_core/layout/PageController';
import { TransactionTypeEdit } from '@client/components/claims/financials/TransactionTypeEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/edit/$transactionTypeId',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit transaction type',
        },
    },
    params: {
        parse({ transactionTypeId }) {
            return {
                transactionTypeId: BigInt(transactionTypeId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <TransactionTypeEdit action={['edit', Route.useParams().transactionTypeId]} />
        </PageController>
    );
}
